import { useState } from "react";

/**
 * Replaces ModalContext for quick-create flows (RevenuePage's "+" menu,
 * CommandCenterProvider's command palette) - plain local state instead of
 * Context, owned separately by each caller. See docs/bug-sheet.md for why
 * this replaced ModalContext + GlobalModals' lazy-workflow-registry pattern.
 */
export const useQuickCreateModals = () => {
  const [activeQuickCreate, setActiveQuickCreate] = useState(null);

  const openModal = (type, props = {}) => setActiveQuickCreate({ type, props });
  const closeQuickCreateModal = () => setActiveQuickCreate(null);

  return {
    activeQuickCreate,
    closeQuickCreateModal,
    openCompanyModal: (props = {}) => openModal("company", props),
    openProposalModal: (props = {}) => openModal("proposal", props),
    openSubscriptionModal: (props = {}) => openModal("subscription", props),
    openInvoiceModal: (props = {}) => openModal("invoice", props),
  };
};
